var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.goodsList),function(item,index){return _c('div',{key:index},[_c('van-card',{staticClass:"base-goodscard",attrs:{"num":item.count,"price":_vm._f("money")(item.currentPrice),"title":item.bookName,"thumb":item.imgUrl}},[_c('img',{staticClass:"goodsItem",attrs:{"src":item.imgUrl,"alt":""}})])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }